import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=d60070f8&scoped=true&"
import script from "./Feeds.vue?vue&type=script&lang=js&"
export * from "./Feeds.vue?vue&type=script&lang=js&"
import style0 from "./Feeds.vue?vue&type=style&index=0&id=d60070f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60070f8",
  null
  
)

export default component.exports